import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef, useLayoutEffect } from 'react';
import { Image } from '../../../patched-avatar/Avatar.mjs';
import { useAvatarContext } from '../../context.mjs';
import { avatarImage } from './image.vanilla.mjs';

const AvatarImage = forwardRef(
  ({ className: classNameFromProps, onError, onLoad, ...props }, forwardedRef) => {
    const { onAvatarImageLoadStatusChange } = useAvatarContext("Avatar.Image");
    const className = classNames(avatarImage, classNameFromProps);
    const handleError = composeEventHandlers(
      onError,
      () => onAvatarImageLoadStatusChange("error")
    );
    const handleLoad = composeEventHandlers(
      onLoad,
      () => onAvatarImageLoadStatusChange("loaded")
    );
    useLayoutEffect(() => {
      if (typeof props.src === "string") {
        onAvatarImageLoadStatusChange("loading");
      }
    }, [onAvatarImageLoadStatusChange, props.src]);
    return /* @__PURE__ */ jsx(
      Image,
      {
        "data-scope": "avatar",
        "data-part": "image",
        className,
        onError: handleError,
        onLoad: handleLoad,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
AvatarImage.displayName = "Avatar.Image";

export { AvatarImage };
//# sourceMappingURL=Image.mjs.map
